<!--
* @Author: zhangping
* @Date: 2025-09-23 09:03:47
* @Description: 采购商品
-->

<template>
    <div>
        <Table :columns="tableConfig.columns" :data="tableConfig.data" :row-class-name="rowClassName">
            <template #brandProductId="{ index }">
                <Select
                    v-model="tableConfig.data[index].brandProductId"
                    placeholder="请输入名称搜索选择"
                    filterable
                    clearable
                    :loading="loadings.goods"
                    @on-open-change="(flag) => changeOepn(flag, index)"
                    :remote-method="(query) => debouncedRemoteGetGoodsList(query, index)"
                    @on-change="(val) => changeGoods(val, index)"
                >
                    <Option
                        v-for="(item, index) in tableConfig.data[index].goodsList"
                        :key="index"
                        :value="item.brandProductId"
                        >{{ item.name }}</Option
                    >
                </Select>
            </template>
            <template #skuSpec="{ row, index }">
                <template v-if="!!row.specInfoList">
                    <div
                        class="skuSpec"
                        v-if="!!tableConfig.data[index].skuSpec"
                        @click="updateSkuSpecModal(row, index)"
                    >
                        {{ tableConfig.data[index].skuSpec }}
                        <Icon type="md-create" style="color: #2d8cf0" class="dn" />
                    </div>
                    <div class="cup" style="color: #2d8cf0" @click="updateSkuSpecModal(row, index)" v-else>请选择</div>
                </template>
                <span v-else>-</span>
            </template>
            <template #quantity="{ index }">
                <InputNumber
                    v-model="tableConfig.data[index].quantity"
                    :precision="0"
                    :max="9999999"
                    placeholder="请输入"
                    style="width: 100%"
                    @on-change="(val) => changeQuantity(val, index)"
                />
            </template>
            <template #action="{ index }">
                <Button
                    type="error"
                    size="small"
                    v-if="tableConfig.data.filter((item) => !item.isHide).length > 1"
                    @click="deleteGoods(index)"
                >
                    删除
                </Button>
                <span v-else>-</span>
            </template>
        </Table>
        <div class="mt-20">
            <Button type="dashed" icon="ios-add" style="width: 800px" @click="addGoods">添加</Button>
        </div>
        <div class="mt-20">
            <span class="dib mr-20">
                订货数量合计：
                <span style="color: #2d8cf0">{{ getTotalOrder('quantity') }}</span>
            </span>
            <span>
                订货金额合计：<span style="color: #2d8cf0">{{ getTotalOrder('purchaseAmount') }}</span>
            </span>
        </div>

        <SkuSpecModal ref="skuSpecModalRef" @onSuccess="updateSpec" />
    </div>
</template>

<script>
import { debounce } from 'lodash';
import SkuSpecModal from './SkuSpecModal';
import { apiPurchaseOrderSelectProduct, apiPurchaseOrderProductDetail } from '@/api/purchase';
import { purchaseGoodsColumns } from '../const';
export default {
    components: { SkuSpecModal },
    props: {
        brandingCompanyId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            brandOwnerId: null,
            tableTemplate: { brandProductId: null, quantity: null },
            tableConfig: {
                columns: purchaseGoodsColumns,
                data: [],
                loading: false,
            },
            goodsList: [],
            loadings: { goods: false },
            editSpecIndex: null,
        };
    },
    mounted() {
        //this.initTable();
    },
    created() {
        this.debouncedRemoteGetGoodsList = debounce(this.remoteGetGoodsList, 300);
    },
    watch: {
        brandingCompanyId: {
            handler(newVal, oldVal) {
                this.brandOwnerId = newVal;
                console.log('brandingCompanyId changed from', oldVal, 'to', newVal);
                this.initTable();
            },
            immediate: true,
        },
    },
    methods: {
        // 初始化表格数据
        initTable() {
            this.tableConfig.data = [{ ...this.tableTemplate, number: 1 }];
        },
        // 添加商品
        addGoods() {
            let cleanData = this.tableConfig.data.filter((item) => !item.isHide);
            this.tableConfig.data.push({ ...this.tableTemplate, number: cleanData.length + 1 });
        },
        // change-下来框打开
        changeOepn(flag, index) {
            if (flag) {
                this.remoteGetGoodsList(this.tableConfig.data[index].productName, index);
            }
        },
        // 远程获取商品列表
        async remoteGetGoodsList(query, index) {
            if (!this.brandOwnerId) {
                return;
            }
            try {
                this.loadings.goods = true;
                const res = await apiPurchaseOrderSelectProduct({
                    brandOwnerId: this.brandOwnerId,
                    name: query,
                    current: 1,
                    size: 100,
                });
                this.tableConfig.data[index].goodsList = res.list;
                this.loadings.goods = false;
            } catch (error) {
                this.loadings.goods = false;
            }
        },
        // 切换商品
        async changeGoods(val, index) {
            if (!val) {
                this.$set(this.tableConfig.data, index, {
                    ...this.tableConfig.data[index],
                    specInfoList: null,
                    minimumPrice: null,
                    productName: null,
                    brandSkuId: null,
                    selectedOptions: {},
                    skuSpec: '',
                    realNumPrice: '',
                });
                this.changeQuantity(this.tableConfig.data[index].quantity, index);
                return;
            }
            const res = await apiPurchaseOrderProductDetail({ brandProductId: val });
            this.$set(this.tableConfig.data, index, {
                ...this.tableConfig.data[index],
                productName: this.tableConfig.data[index].goodsList.find((item) => item.brandProductId === val).name,
                specInfoList: res.specInfo ? JSON.parse(res.specInfo) : null,
                onShelfSkuList: res.onShelfSkuList,
                minimumPrice: res.minimumPrice,
                selectedOptions: {},
                skuSpec: '',
                realNumPrice: '',
            });
            this.changeQuantity(this.tableConfig.data[index].quantity, index);
        },
        // 更新sku规格
        updateSkuSpecModal(row, index) {
            this.editSpecIndex = index;
            this.$refs.skuSpecModalRef.open(row);
        },
        // 更新规格
        updateSpec(selectedOptions, idListToLabel, realNumPrice, brandSkuId) {
            const item = this.tableConfig.data[this.editSpecIndex];
            item.selectedOptions = selectedOptions;
            item.skuSpec = idListToLabel;
            item.realNumPrice = realNumPrice;
            item.brandSkuId = brandSkuId;
            if (item.realNumPrice) {
                item.purchaseAmount = item.quantity * item.realNumPrice;
            }
        },
        // 删除商品
        deleteGoods(index) {
            this.$set(this.tableConfig.data[index], 'isHide', true);
            this.$nextTick(() => {
                let visibleIndex = 1;
                this.tableConfig.data.forEach((item) => {
                    if (!item.isHide) {
                        this.$set(item, 'number', visibleIndex++);
                    }
                });
            });
        },
        rowClassName(row) {
            if (row.isHide) {
                return 'boxxxxxx';
            }
        },
        // change数量
        changeQuantity(val, index) {
            this.tableConfig.data[index].purchaseAmount =
                val * (this.tableConfig.data[index].realNumPrice || this.tableConfig.data[index].minimumPrice);
        },
        // 订货数量合计、订货金额合计
        getTotalOrder(key) {
            let cleanData = this.tableConfig.data.filter((item) => !item.isHide);
            let total = cleanData
                .filter((item) => item[key])
                .map((item) => {
                    return item[key];
                })
                .reduce((acc, curr) => acc + curr, 0);
            return total;
        },
        // 获取sku相同清空对应的索引序号
        getSameIndexNumber(list, key) {
            const idIndexes = {};
            list.forEach((item, index) => {
                const _key = item[key];
                if (!idIndexes[_key]) {
                    idIndexes[_key] = [];
                }
                idIndexes[_key].push(index);
            });
            const allSameIndexes = [];
            for (const el in idIndexes) {
                const indexes = idIndexes[el];
                if (indexes.length > 1) {
                    allSameIndexes.push(...indexes);
                }
            }
            return allSameIndexes;
        },
        // 获取商品列表
        getGoodsList() {
            let flag = true;
            let cleanData = this.tableConfig.data.filter((item) => !item.isHide);
            for (const item of cleanData) {
                if (!item.brandProductId) {
                    this.$Message.warning('请选择商品');
                    flag = false;
                    break;
                }
                if (!!item.specInfoList && !item.brandSkuId) {
                    this.$Message.warning('请选择规格');
                    flag = false;
                    break;
                }
                if (!item.quantity) {
                    this.$Message.warning('请填写数量');
                    flag = false;
                    break;
                }
            }
            if (!flag) {
                return false;
            }
            let result = cleanData.map((item) => ({
                brandProductId: item.brandProductId,
                brandSkuId: item.brandSkuId || item.onShelfSkuList[0].brandSkuId, // 多sku || 单sku
                quantity: item.quantity,
            }));
            const sameNum = this.getSameIndexNumber(result, 'brandSkuId').map((el) => ++el);
            if (sameNum.length > 0) {
                this.$Message.warning(`商品重复，序号[${sameNum.join('、')}]`);
                return false;
            }
            return result;
        },
    },
};
</script>

<style lang="less" scoped>
.ivu-table-wrapper {
    overflow: visible;
}
/deep/ .ivu-table-cell {
    overflow: visible;
}
/deep/ .ivu-table .boxxxxxx {
    display: none;
}
.skuSpec {
    &:hover {
        .ivu-icon {
            display: inline-block;
            cursor: pointer;
        }
    }
}
</style>
